import classNames from "classnames";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import { getCentAmount } from "../../../../util/helper/getCentAmount";
import { parseDollarAmt } from "../../../../util/helper/parseDollarAmt";
import cssStyles from "./price.module.scss";

// export const TYPE_MAP = {
//   small: "small",
//   medium: "medium",
//   large: "large",
// };

function Price(props: any) {
  const router = useRouter();
  const { locale } = router;
  const {
    product, price = product?.price, className = "", size = "medium", style, sameSize = false,
  } = props;

  const cents = getCentAmount(price);

  const currencyEn = sameSize ? <span>CA$ </span> : <sup>CA$ </sup>;
  const currencyFr = sameSize ? <span>$CA </span> : <sup>$CA </sup>;
  const centsText = sameSize ? <span>{`.${cents}`}</span> : (
    <sup>
      {`.${cents}`}
    </sup>
  );

  return (
    <div
      className={classNames(`${cssStyles.common} ${cssStyles[size]} ${className}`, {
        [cssStyles[`same_size_${size}`]]: sameSize,
      })}
      data-testid="item-price"
      style={style}
      data-clarity-unmask="true"
    >
      <HideIf show={locale === "en"}>
        {currencyEn}
      </HideIf>

      <span>
        {parseDollarAmt(price)}
      </span>

      {
        cents && (
          centsText
        )
      }

      <HideIf show={locale === "fr"}>
        {currencyFr}
      </HideIf>
    </div>
  );
}

export default Price;
